module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("NOTE FOR THE SECOND REVISED EDITION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When this biography was first published by Harcourt Brace Jovanovich in 1981, my claim that its publication was justified by “more facts” did not pass unnoticed. One practicing biographer protested that biography should not be limited by facts. A one-book biographer declared that too much evidence interferes with the free play of the biographer’s insights. It is free because it has not been paid for by research; it may indeed become a form of play.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Facts are the only things a biographer can trust—and only after they have been verified. Insights are as good as the evidence that supports them. This revised edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Sort of Epic Grandeur")]), _vm._v(" provides still more facts, as well as corrections of the first edition.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scottie Fitzgerald died 18 June 1986. She was the best thing I got from F. Scott Fitzgerald. This is the truth: I could not and would not have done my “Daddy books” without Scottie. She provided material and contacts. She made it all fun. The party is over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-r"
  }, [_vm._v("M.J.B.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-r1"
  }, [_vm._v("21 August 2001")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c4f1384","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Revised_edition.vue
// module id = 78
// module chunks = 0